export const STATE = {
  pageHeight: 'pageHeight',
  lang: 'lang',
  support: 'support',
  isTouchDevice: 'isTouchDevice',
  isInteracting: 'isInteracting',
  direction: 'direction',
  isRetina: 'isRetina',
  canAutoPlayVideo: 'canAutoPlayVideo',
  showLangSwitcher: 'showLangSwitcher',
  windowH: 'windowH',
  mediaQuery: 'mediaQuery',
  enableLazyLoad: 'enableLazyLoad',
  documentHeight: 'documentHeight',
  gtmEventsSent: 'gtmEventsSent',
  locations: 'locations',
  poops: 'poops',
  colorScheme: 'colorScheme',
  images: 'images',
  globalData: 'globalData'
}

export const GETTERS = {
  support: 'support',
  lang: 'lang',
  isTabletDevice: 'isTabletDevice',
  isMobileDevice: 'isMobileDevice',
  isGtmEventSent: 'isGtmEventSent',
  locations: 'locations',
  poops: 'poops',
  colorScheme: 'colorScheme',
  images: 'images',
  globalData: 'globalData'
}

export const MUTATIONS = {
  support: 'M_support',
  lang: 'M_lang',
  mediaQuery: 'M_MEDIA-QUERY',
  pageHeight: 'M_PAGE-HEIGHT',
  windowH: 'M_WINDOW_H',
  autoplayVideo: 'M_autoplay-video',
  direction: 'M_direction',
  enableLazyLoad: 'M_ennableLazyLoad',
  documentHeight: 'M_documentHeight',
  sendGtmEvent: 'M_sendGtmEvent',
  isInteracting: 'M_isInteracting',
  locations: 'M_locations',
  poops: 'M_poops',
  colorScheme: 'M_colorScheme',
  images: 'M_images',
  globalData: 'M_globalData'
}
